<div class="dialog">
    <h2 mat-dialog-title class="header warning">
        <span class="title">{{ 'event_steps.step_privacy.blur_warning_dialog.title' | translate }}</span>
        <button class="close-ref" mat-icon-button (click)="closeAndCancel()"
            [title]="'general.close' | translate | titlecase">
            <mat-icon>clear</mat-icon>
        </button>
    </h2>
    <div class="profile-content" mat-dialog-content>
        <div class="similar-content" [innerHTML]="'event_steps.step_privacy.blur_warning_dialog.explain_text' | translate"></div>
    </div>
    <div mat-dialog-actions class="dialog-buttons">
        <button class="close-ref" mat-flat-button (click)="closeAndCancel()" [color]="'primary'"
            [title]="'general.cancel' | translate">
            {{ 'general.cancel' | translate }}
        </button>
        <button mat-stroked-button (click)="closeAndProceed()" class="warning bold" [title]="'general.continue' | translate | titlecase">
            {{ 'general.continue' | translate }}
        </button>
    </div>
</div>